require('../../common/directives/jv.root-modal.directive');
require('../../common/directives/jv.LoadingButton');
require('../../common/jv.PromiseQueue');
require('../../common/jv.Debounce');
require('./jv.search.save.service');

angular.module('jv.search.save-list-modal.directive', [
    'jv.common.root-modal.directive',
    'jv.Common.Directives.LoadingButton',
    'jv.Common.PromiseQueue',
    'jv.Common.Debounce',
    'jv.search.save.service',
    'jv.Common.i18n'
])
.controller('jvSearchSaveListModalController', [
    '$scope', 'jvSearchSaveService', 'PromiseQueue', 'i18n', 'debounce',
    function($scope, jvSearchSaveService, PromiseQueue, i18n, debounce) {
        var selectLoading = new PromiseQueue();

        function setState() {
            $scope.state = {
                page: 0
            };
            updateList();
        }

        function updateList() {
            var page = $scope.state.page;
            var query = $scope.state.query;
            var perPage = 10;
            jvSearchSaveService.list(page, query, perPage).then(function(data) {
                angular.extend($scope.state, {
                    list: data.results,
                    total: data.total,
                    hasPrevious: (page > 0),
                    hasNext: (data.total > perPage * (page + 1)),
                    currentStart: page * perPage + 1,
                    currentEnd: page * perPage + data.results.length
                });
                $scope.state.selectedSearch = null;
                $scope.state.searchLoading = false;
            });
        }

        function showOperationError(message) {
            $scope.$emit('showMessageBar', {
                message: message || i18n['UNABLE_TO_PERFORM_OPERATION'],
                type: 'error'
            });
        }

        $scope.nextPage = function() {
            $scope.state.page++;
            updateList();
        }

        $scope.previousPage = function() {
            $scope.state.page--;
            updateList();
        }

        $scope.select = function() {
            var process;
            process = jvSearchSaveService.get($scope.state.selectedSearch);
            selectLoading.enqueue(process);
            process.then(function(data) {
                $scope.onSelect({
                    search: data
                });
                $scope.hide();
                $scope.$emit('ignoreFilterChange');
            }, showOperationError);
        };

        $scope.delete = function(search) {
            var process = jvSearchSaveService.delete(search.EId);
            process.then(function() {
                if ($scope.state.list.length === 1 && $scope.state.page > 0) {
                    $scope.state.page--;
                }
                updateList();
            }, showOperationError);
        };

        $scope.edit = function(search) {
            search.editing = true;
            $scope.state.editing = true;
            $scope.state.searchName = search.searchName;
        };

        $scope.saveEdit = function(search) {
            var process = jvSearchSaveService.update(search.EId, $scope.state.searchName);
            process.then(function() {
                search.searchName = $scope.state.searchName;
                search.editing = false;
                $scope.state.editing = false;
            }, function(response) {
                var message;
                if (response && response.status === 409) {
                    message = i18n['DUPLICATE_SEARCH_NAME'];
                }

                showOperationError(message);
            });
        };

        $scope.cancelEdit = function(search) {
            search.editing = false;
            $scope.state.editing = false;
            $scope.state.searchName = null;
        };

        $scope.isLoading = function() {
            return (selectLoading.length > 0);
        };

        $scope.$watch('show', function(val) {
            if (val) {
                setState();
            }
        });

        $scope.$watch('state.query', debounce(function() {
            if ($scope.state) {
                $scope.state.page = 0;
                updateList();
            }
        }, 800));

        $scope.$watch('state.query', function() {
            if ($scope.state) {
                $scope.state.searchLoading = true;
            }
        });
    }
])
.directive('jvSearchSaveListModal', [
    function() {
        return {
            scope: {
                hide: '&',
                show: '=',
                onSelect: '&'
            },
            controller: 'jvSearchSaveListModalController',
            templateUrl: 'modals/saveSearchList.html'
        }
    }
]);